var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-main',{scopedSlots:_vm._u([{key:"toolbar",fn:function(){return [_c('layout-tool-bar',{attrs:{"title":_vm.title}})]},proxy:true},{key:"footer",fn:function(){return [_c('layout-footer',{on:{"click:tab":_vm.navigate}})]},proxy:true}])},[_c('v-container',{staticClass:"fill-wh"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }